import { type Components, type Theme } from "@mui/material/styles";

export const menu: Components<Theme>["MuiMenu"] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[1],
      borderRadius: theme.shape.borderRadius,
    }),
  },
};
